import moment from 'moment';
import { LENTE_IDS } from './constants';

const KEY_PREFIX = 'digitacao.metaPessoal';

export const META_PESSOAL_PRESETS = {
  [LENTE_IDS.MT_BT]: [35, 45, 55],
  [LENTE_IDS.USO_MUTUO]: [120, 140, 160],
};

export const toCicloIso = (value) => {
  if (value == null) return null;
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
};

export const buildMetaPessoalKey = (lenteId, inicio, fim) => {
  const inicioIso = toCicloIso(inicio);
  const fimIso = toCicloIso(fim);
  if (!lenteId || !inicioIso || !fimIso) return null;
  return `${KEY_PREFIX}.${lenteId}.${inicioIso}.${fimIso}`;
};

export const getMetaPessoalPresets = (lenteId, metaDiaria) => {
  const base = lenteId === LENTE_IDS.USO_MUTUO
    ? META_PESSOAL_PRESETS[LENTE_IDS.USO_MUTUO]
    : META_PESSOAL_PRESETS[LENTE_IDS.MT_BT];
  if (metaDiaria != null && Number.isFinite(metaDiaria) && !base.includes(metaDiaria)) {
    return [metaDiaria, ...base].sort((a, b) => a - b);
  }
  return base;
};

export const parseMetaPessoalValue = (raw) => {
  const n = Number(raw);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.round(n);
};

export const readMetaPessoal = ({ lenteId, inicio, fim }) => {
  const key = buildMetaPessoalKey(lenteId, inicio, fim);
  if (!key || typeof sessionStorage === 'undefined') return null;
  try {
    return parseMetaPessoalValue(sessionStorage.getItem(key));
  } catch {
    return null;
  }
};

export const writeMetaPessoal = ({ lenteId, inicio, fim, alvo }) => {
  const key = buildMetaPessoalKey(lenteId, inicio, fim);
  if (!key || typeof sessionStorage === 'undefined') return;
  try {
    const parsed = parseMetaPessoalValue(alvo);
    if (parsed == null) {
      sessionStorage.removeItem(key);
      return;
    }
    sessionStorage.setItem(key, String(parsed));
  } catch {
    // sessionStorage indisponível (modo privado)
  }
};

export const resolveAlvoDiario = ({
  isAdminMode,
  lenteId,
  inicio,
  fim,
  metaDiaria,
}) => {
  if (isAdminMode) return metaDiaria ?? null;
  const stored = readMetaPessoal({ lenteId, inicio, fim });
  return stored ?? metaDiaria ?? null;
};

export const computeMetaPeriodoPessoal = (alvoDiario, diasUteis) => {
  if (alvoDiario == null || diasUteis == null) return null;
  if (!Number.isFinite(alvoDiario) || !Number.isFinite(diasUteis)) return null;
  return Math.round(alvoDiario * diasUteis);
};
